var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.858,
    height: 29,
    viewBox: "0 0 45.858 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "view_password",
    "data-name": "view password",
    d: "M56.027,34.177c0-3.421,9.334-14.5,22.921-14.5,13.786,0,22.938,11.079,22.938,14.5,0,3.388-9.135,14.5-22.938,14.5C65.345,48.677,56.027,37.565,56.027,34.177Zm41.274,0C97.3,32.25,89.246,23.4,78.948,23.4c-10.314,0-18.337,8.853-18.337,10.779,0,2.276,8.022,10.78,18.337,10.78C89.246,44.957,97.3,36.453,97.3,34.177Zm-26.974,0a8.629,8.629,0,0,1,17.257,0,8.629,8.629,0,0,1-17.257,0Zm11.344,0a2.716,2.716,0,1,0-2.724,2.691A2.711,2.711,0,0,0,81.672,34.177Z",
    transform: "translate(-56.027 -19.677)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.dcbba30663d2d5ae9caefa703082ef06.svg";
export { ForwardRef as ReactComponent };